var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-apex-charts',{attrs:{"height":"277","options":_vm.options,"series":_vm.series_socioeconomic}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }